import './App.css'
import { Routes, Route } from "react-router-dom"
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Gallery from './pages/Gallery'
import Contact from './pages/Contact'
import BestCatering from './pages/BestCatering'

function App() {
  return (
    <div >
      <Routes>
        <Route className="App" path="/" element={<Home />} />
        <Route className="App" path="about" element={<About />} />
        <Route className="App" path="services" element={<Services />} />
        <Route className="App" path="gallery" element={<Gallery />} />
        <Route className="App" path="contact" element={<Contact />} />
        <Route path="best-catering-services-in-kochi" element={<BestCatering />} />
      </Routes>
    </div>
  );
}

export default App;
